import styled from 'styled-components';
import { PageHeader } from 'ui/pageHeader';
import { FullWidth } from 'ui/utility/fullWidth';
import { colors, H4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Badge } from 'ui/badge';

export const Layout = styled(FullWidth)`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  gap: ${spacing.double};
  padding: ${spacing.x3} ${pxToRem(40)};
  background-color: ${colors.grey1};
`;

export const LeftColumn = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: ${pxToRem(320)};
`;

export const RightColumn = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: ${pxToRem(320)};
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
`;

export const StyledPageHeader = styled(PageHeader)`
  margin-top: ${pxToRem(42)};
  margin-bottom: ${pxToRem(58)};
`;

export const SectionHeader = styled.div`
  display: flex;
  gap: ${spacing.base};
  flex-wrap: wrap;
  align-items: center;
`;

export const SectionHeading = styled(H4)`
  flex-grow: 1;
  margin-bottom: 0;
`;

export const Ul = styled.ul`
  padding-left: ${spacing.base};
  margin-bottom: 0;
  & > li {
    list-style-type: disc;
    word-break: break-word;
  }

  & > li span:last-child {
    display: inline-block;
    margin-left: ${spacing.quarter};
  }
`;

export const BadgeWithLeftMargin = styled(Badge)`
  margin-left: ${spacing.half};
`;
